(ns practitest.frontend.reports.subs
  (:require
   [clojure.string          :as string]
   [re-frame.core           :as re-frame]
   [practitest.frontend.reports.utils  :as ru]
   [practitest.frontend.common-old-fe.utils   :as cu]
   [practitest.frontend.common-old-fe.logging :as log]
   [practitest.frontend.common-old-fe.i18n    :as i18n]))

;; ===========================================================================
;; utils

(defn manual-rd? [rd]
  (= "manual" (get-in rd [:schedule :type])))

(def scheduled-rd? (complement manual-rd?))

(defn rd->instance [rd]
  {:rd-id        (:id rd)
   :rd           rd
   :entity       (:entity rd)
   :instance-uri (:instance-uri rd)
   :owner        (:owner rd)
   :download-uri (:download-uri rd)
   :type         (:type rd)
   :schedule     (:schedule rd)
   :name         (:name rd)})

(defmulti schedule-ts :type)
(defmethod schedule-ts "daily" [_]
  (-> (js/moment) (.startOf "day") (.add 1 "d") (.add 6 "h") .unix))
(defmethod schedule-ts "weekly" [{:keys [week-day]}]
  (-> (js/moment) (.startOf "day") (.day week-day) (.add 6 "h") .unix))
(defmethod schedule-ts "monthly" [{:keys [month-day]}]
  (let [ts (-> (js/moment) (.startOf "month") (.add 6 "h"))]
    (case month-day
      "first" (-> ts (.add 1 "M") .unix)
      "15th"  (if (> (.date (js/moment)) 15)
                (-> ts (.add 1 "M") (.date 15) .unix)
                (-> ts (.date 15) .unix))
      "last"  (-> ts (.date (.date (.endOf (js/moment) "month"))) .unix))))

(defn future-timestamp [rd]
  (schedule-ts (:schedule rd)))

(defn unscrew-auto-filter-id [raw-id]
  (if (string? raw-id)
    (let [[id v] (cu/parse-auto-filter-id raw-id)]
      (if v (str id "-" v) id))
    raw-id))

;; ===========================================================================
;; subscriptions

(re-frame/reg-sub
  :reports/init-complete?
  (fn [db _]
    (:init-complete? db)))

(re-frame/reg-sub
 :reports/view
 (fn [db _]
   (:view db)))

(re-frame/reg-sub
 :reports/current-page
 (fn [db _]
   (:page db)))

(re-frame/reg-sub
 :reports/per-page
 (fn [db _]
   (:per-page db)))

(re-frame/reg-sub
 :reports/enterprise?
 (fn [db _]
   (:enterprise db)))

(re-frame/reg-sub
 :reports/help-image-url
 (fn [db _]
   (:help-image-url db)))

(re-frame/reg-sub
 :reports/total-pages
 (fn [db _]
   (js/Math.ceil (/ (:total db) (:per-page db)))))

(re-frame/reg-sub
 :reports/pages
 (fn [db _]
   (let [npages (re-frame/subscribe [:reports/total-pages])]
     (range 1 (inc @npages)))))

(re-frame/reg-sub
 :reports/current-rd
 (fn [db _]
   (:current-rd db)))

(re-frame/reg-sub
 :reports/current-cvs
 (fn [db _]
   (let [entity (get-in db [:current-rd :entity])
         entity (if (= "Run" entity) "Instance" entity)]
     (->> (get-in db [:cvs (keyword entity)])
          (map (fn [[name id fields]]
                 (let [fields (vec
                               (if (some #(= "id" %) fields)
                                 fields
                                 (cons "id" fields)))]
                   [(if (nil? id)
                      (str name " (No Filter)")
                      name)
                    (unscrew-auto-filter-id id)
                    fields])))))))

(re-frame/reg-sub
 :reports/default-fields
 (fn [db _]
   (reduce (fn [res [k v]]
             (assoc res k (ru/default-fields v)))
           {}
           (:cvs db))))

(re-frame/reg-sub
 :reports/fields
 (fn [db _]
   (:report-fields db)))

(re-frame/reg-sub
 :reports/current-all-fields
 (fn [db _]
   (let [entity (get-in db [:current-rd :entity])]
     (get-in db [:report-fields (keyword entity)]))))

(re-frame/reg-sub
 :reports/current-selected-fields
 (fn [db _]
   (get-in db [:current-rd :fields])))

(re-frame/reg-sub
 :reports/current-all-charts
 (fn [db _]
   (let [entity     (get-in db [:current-rd :entity])
         fields-map (->> (get-in db [:report-fields (keyword entity)])
                        (map #(vector (:field %) %))
                        (into {}))]
        (->> (get-in db [:current-rd :fields])
             (map #(get fields-map %))
             (filter ru/chartable-field?)))))

(re-frame/reg-sub
 :reports/modal-dirty?
 (fn [db _]
   (boolean (get-in db [:modal-data :dirty?]))))

(re-frame/reg-sub
 :reports/modal-re-run?
 (fn [db _]
   (boolean (get-in db [:modal-data :re-run?]))))

(re-frame/reg-sub
 :reports/current-selected-charts
 (fn [db _]
   (get-in db [:current-rd :charts])))

(re-frame/reg-sub
 :reports/modal-data
 (fn [db _]
   (:modal-data db)))

(re-frame/reg-sub
 :reports/confirmation-dialog
 (fn [db _]
   (:confirmation-dialog db)))

(re-frame/reg-sub
 :reports/users
 (fn [db _]
   (:users db)))

(re-frame/reg-sub
 :reports/current-user
 (fn [db _]
   (:me db)))

(re-frame/reg-sub
 :reports/report-definitions
 (fn [db _]
   (->> (:report-definitions db)
        vals
        (sort-by :last-modified >))))

(re-frame/reg-sub
 :reports/has-migrated-reports?
 (fn [db _]
   (some #(:schedule_migrated %) (vals (:report-definitions db)))))

;; TODO: download-uri should be in the instance level (basically the key should be part of the URL)
;;       only format is passed. The only issue here is that it's a POST and not GET.
(re-frame/reg-sub
 :reports/report-instances
 (fn [db _]
   (->> (:report-definitions-order db)
        (map (fn [rd-id]
               (if-let [rd (get-in db [:report-definitions rd-id])]
                 (cond
                   (and (scheduled-rd? rd) (empty? (:instances rd)))
                   (assoc (rd->instance rd)
                          :timestamp (future-timestamp rd)
                          :future? true)

                   (empty? (:instances rd))
                   (assoc (rd->instance rd)
                          :empty? true)

                   :else
                   (let [[last-instance & history] (sort-by #(get % :timestamp js/Number.MAX_VALUE) > (:instances rd))]
                     (merge last-instance
                            (rd->instance rd)
                            {:history (map #(merge % (rd->instance rd)) history)})))
                 (log/warn :reports/report-instances "Couldn't find rd" rd-id)))))))

(re-frame/reg-sub
 :reports/loading?
 (fn [db _]
   (:loading? db)))

(re-frame/reg-sub
  :reports/testset-id-for-instances-filter
  (fn [db _]
      (:testset-id-for-instances-filter db)))

(re-frame/reg-sub
 :reports/issue-cvs
 (fn [db _]
   (:issue-cvs db)))

(re-frame/reg-sub
 :reports/report-definition-updating?
 (fn [db _]
   (:report-definition-updating? db)))

(re-frame/reg-sub
 :reports/instances-refreshing
 (fn [db _]
   (:instances-refreshing db)))

(re-frame/reg-sub
 :reports/download-url
 (fn [db [_ rd s3-url]]
   (str (:download-uri rd) "?key=" (js/encodeURIComponent s3-url))))

(re-frame/reg-sub
 :reports/entity-fields
 (fn [db [_ entity]]
   (get-in db [:report-fields (keyword entity)])))

(re-frame/reg-sub
 :reports/expanded-instances
 (fn [db _]
   (:expanded-instances db)))

(re-frame/reg-sub
 :reports/run-statuses
 (fn [db _]
   (:run-statuses db)))

(re-frame/reg-sub
 :reports/error
 (fn [db _]
   (:error db)))

(re-frame/reg-sub
 :reports/aggregation-fields
 (fn [db [_ entity]]
   (let [fields (get-in db [:report-fields (keyword entity)])
         custom-field? (fn [field]
                         (or
                          (string/starts-with? (:field field) "___f_")
                          (string/starts-with? (:field field) "testset:___f_")
                          (string/starts-with? (:field field) "test:___f_")
                          (string/starts-with? (:field field) "instance:___f_")
                          (string/starts-with? (:field field) "lastrun:___f_")))
         local-field? (fn [field]
                        (or
                         (nil? (string/index-of (:field field) \:))
                         (string/starts-with? (:field field) "testset:")
                         (string/starts-with? (:field field) "test:")
                         (string/starts-with? (:field field) "instance:")
                         (string/starts-with? (:field field) "lastrun:")))
         list-field? (fn [field]
                       (contains? #{"list" "linkedlist" "user"} (:type field)))
         valid-field? (fn [field]
                        (or (contains? #{"version" "priority" "test:version" "lastrun:version" "instance:version" "testset:version" "test:priority" "testset:priority"} (:field field))
                            (and (local-field? field)
                                 (custom-field? field)
                                 (list-field? field))))]
     (->> fields
          (filter valid-field?)
          (map (fn [field]
                 [(:field field) (:name field)]))))))

(re-frame/reg-sub
 :reports/selected-entity
 (fn [db _]
   (get-in db [:current-rd :entity])))

(re-frame/reg-sub
 :reports/selected-entity-key
 (fn [db _]
   (:selected-entity-key db)))

(re-frame/reg-sub
 :reports/selected-type
 (fn [db _]
   (get-in db [:current-rd :type])))

(re-frame/reg-sub
 :reports/selected-type-name
 (fn [db _]
   (:selected-report-type-name db)))

(re-frame/reg-sub
 :reports/selected-choice
 (fn [db _]
   (:selected-choice db)))

(re-frame/reg-sub
 :reports/get-choices
 (fn [_ _]
   {:requirement {:types {"tabular" {:type                         (i18n/t :tabular_summary)
                                     :dom-id                       "requirements-tabular"
                                     :image                        [:reports/tabular-report-image-url]
                                     :image-example                [:reports/requirements-tabular-img]
                                     :star                         false
                                     :short-desc                   (i18n/t :tabular_summary_short_desc)
                                     :long-text                    (i18n/t :tabular_summary_long_text)}
                          "tabular-traceability" {:type            (i18n/t :tabular_traceability)
                                                  :dom-id          "requirements-tabular-traceability"
                                                  :image           [:reports/traceability-report-image-url]
                                                  :image-example   [:reports/requirements-tabular-traceability-img]
                                                  :star            true
                                                  :short-desc      (i18n/t :tabular_traceability_short_desc)
                                                  :long-text       (i18n/t :tabular_traceability_long_text)}
                          "detailed" {:type                        (i18n/t :detailed)
                                      :dom-id                      "requirements-detailed"
                                      :image                       [:reports/detailed-report-image-url]
                                      :image-example               [:reports/requirements-detailed-img]
                                      :star                        false
                                      :short-desc                  (i18n/t :detailed_short_desc)
                                      :long-text                   (i18n/t :detailed_long_text)}}
                  :object-name "Requirement"
                  :header      (i18n/t :requirement_header)}
    :instances {:types {"tabular-aggregated" {:type           (i18n/t :tabular_aggregated)
                                              :dom-id         "instances-tabular-aggregated"
                                              :image          [:reports/tabular-aggregated-image-url]
                                              :image-example  [:reports/instances-tabular-aggregated-img]
                                              :star           false
                                              :short-desc     (i18n/t :tabular_aggregated_short_desc)
                                              :long-text      (i18n/t :tabular_aggregated_long_text)}
                        "tabular-with-steps" {:type           (i18n/t :tabular_with_steps)
                                              :dom-id         "instances-tabular-with-steps"
                                              :image          [:reports/tabular-steps-image-url]
                                              :image-example  [:reports/instances-tabular-with-steps-img]
                                              :star           false
                                              :short-desc     (i18n/t :tabular_with_steps_short_desc)
                                              :long-text      (i18n/t :tabular_with_steps_long_text)}
                        "tabular" {:type                      (i18n/t :tabular_summary)
                                   :dom-id                    "instances-tabular"
                                   :image                     [:reports/tabular-report-image-url]
                                   :image-example             [:reports/instances-tabular-img]
                                   :star                      true
                                   :short-desc                (i18n/t :tabular_summary_short_desc)
                                   :long-text                 (i18n/t :tabular_summary_instance_long_text)}
                        "detailed" {:type                     (i18n/t :detailed)
                                    :dom-id                   "instances-detailed"
                                    :image                    [:reports/detailed-report-image-url]
                                    :image-example            [:reports/instances-detailes-img]
                                    :star                     true
                                    :short-desc               (i18n/t :detailed_instances_short_desc)
                                    :long-text                (i18n/t :detailed_instances_long_text)}
                        "detailed-with-attachments" {:type                     (i18n/t :detailed_with_attachments)
                                                     :dom-id                   "instances-detailed-with-attachments"
                                                     :image                    [:reports/detailed-report-image-url]
                                                     :image-example            [:reports/instances-detailed-with-attachments-img]
                                                     :star                     true
                                                     :short-desc               (i18n/t :detailed_instances_short_desc)
                                                     :long-text                (i18n/t :detailed_with_attachments_long_text)}}
                :object-name "Instance"
                :header      (i18n/t :instances_header)}

    :tests {:types {"tabular" {:type                       (i18n/t :tabular_summary)
                               :dom-id                     "tests-tabular"
                               :image                      [:reports/tabular-report-image-url]
                               :image-example              [:reports/test-tabular-img]
                               :star                       false
                               :short-desc                 (i18n/t :tabular_summary_short_desc)
                               :long-text                  (i18n/t :tabular_summary_tests_long_text)}
                    "detailed" {:type                      (i18n/t :detailed)
                                :dom-id                    "tests-detailed"
                                :image                     [:reports/detailed-report-image-url]
                                :image-example             [:reports/test-detailed-img]
                                :star                      true
                                :short-desc                (i18n/t :detailed_short_desc)
                                :long-text                 (i18n/t :detailed_long_text)}
                    "tabular-with-steps" {:type            (i18n/t :tabular_with_steps)
                                          :dom-id          "tests-tabular-with-steps"
                                          :image           [:reports/tabular-steps-image-url]
                                          :image-example   [:reports/test-tabular-summaries-img]
                                          :star            false
                                          :short-desc      (i18n/t :tabular_with_steps_tests_short_desc)
                                          :long-text       (i18n/t :tabular_with_steps_tests_long_text)}}
            :object-name "Test"
            :header      (i18n/t :tests_header)}
    :testsets {:types {"tabular" {:type             (i18n/t :tabular_summary)
                                  :dom-id           "testsets-tabular"
                                  :image            [:reports/tabular-report-image-url]
                                  :image-example    [:reports/test-set-tabular-img]
                                  :star             false
                                  :short-desc       (i18n/t :tabular_summary_short_desc)
                                  :long-text        (i18n/t :tabular_summary_testsets_long_text)}
                       "detailed" {:type            (i18n/t :detailed)
                                   :dom-id          "testsets-detailed"
                                   :image           [:reports/detailed-report-image-url]
                                   :image-example   [:reports/test-set-detailed-img]
                                   :star            false
                                   :short-desc      (i18n/t :detailed_testsets_short_desc)
                                   :long-text       (i18n/t :detailed_testsets_long_text)}}
               :object-name "TestSet"
               :header      (i18n/t :testsets_header)}
    :issues {:types {"tabular" {:type           (i18n/t :tabular_summary)
                                :dom-id         "issues-tabular"
                                :image          [:reports/tabular-report-image-url]
                                :image-example  [:reports/issues-tabular-img]
                                :star           true
                                :short-desc     (i18n/t :tabular_summary_short_desc)
                                :long-text      (i18n/t :tabular_summary_long_text)}
                     "detailed" {:type          (i18n/t :detailed)
                                 :dom-id        "issues-detailed"
                                 :image         [:reports/detailed-report-image-url]
                                 :image-example [:reports/issues-detailes-img]
                                 :star          false
                                 :short-desc    (i18n/t :detailed_issues_short_desc)
                                 :long-text     (i18n/t :detailed_issues_long_text)}}
             :object-name "Issue"
             :header      (i18n/t :issues_header)}
    :runs {:types {"tabular-aggregated" {:type           (i18n/t :tabular_aggregated)
                                         :dom-id         "runs-tabular-aggregated"
                                         :image          [:reports/tabular-aggregated-image-url]
                                         :image-example  [:reports/run-tabular-aggregated-img]
                                         :star           false
                                         :short-desc     (i18n/t :tabular_aggregated_short_desc)
                                         :long-text      (i18n/t :tabular_aggregated_runs_long_text)}
                   "tabular-with-steps" {:type            (i18n/t :tabular_with_steps)
                                         :dom-id          "runs-tabular-with-steps"
                                         :image           [:reports/tabular-steps-image-url]
                                         :image-example   [:reports/run-tabular-with-steps-img]
                                         :star            false
                                         :short-desc      (i18n/t :tabular_with_steps_tests_short_desc)
                                         :long-text       (i18n/t :tabular_with_steps_runs_long_text)}
                              "tabular" {:type           (i18n/t :tabular_summary)
                                         :dom-id         "runs-tabular"
                                         :image          [:reports/tabular-report-image-url]
                                         :image-example  [:reports/run-tabular-img]
                                         :star           true
                                         :short-desc     (i18n/t :tabular_summary_short_desc)
                                         :long-text      (i18n/t :tabular_summary_run_long_text)}}
             :object-name "Run"
             :header      (i18n/t :runs_header)}}))

(re-frame/reg-sub
 :reports/tabular-report-image-url
 (fn [db _]
   (:tabular-report-image-url db)))

(re-frame/reg-sub
 :reports/tabular-aggregated-image-url
 (fn [db _]
   (:tabular-aggregated-image-url db)))

(re-frame/reg-sub
 :reports/tabular-steps-image-url
 (fn [db _]
   (:tabular-steps-image-url db)))

(re-frame/reg-sub
 :reports/traceability-report-image-url
 (fn [db _]
   (:traceability-report-image-url db)))

(re-frame/reg-sub
 :reports/detailed-report-image-url
 (fn [db _]
   (:detailed-report-image-url db)))

(re-frame/reg-sub
 :reports/recomended-image-url
 (fn [db _]
   (:recomended-image-url db)))

(re-frame/reg-sub
 :reports/instances-detailes-img
 (fn [db _]
   (:instances-detailes-img db)))

(re-frame/reg-sub
  :reports/instances-detailed-with-attachments-img
  (fn [db _]
      (:instances-detailed-with-attachments-img db)))

(re-frame/reg-sub
 :reports/instances-tabular-aggregated-img
 (fn [db _]
   (:instances-tabular-aggregated-img db)))

(re-frame/reg-sub
 :reports/instances-tabular-img
 (fn [db _]
   (:instances-tabular-img db)))

(re-frame/reg-sub
 :reports/instances-tabular-with-steps-img
 (fn [db _]
   (:instances-tabular-with-steps-img db)))

(re-frame/reg-sub
 :reports/issues-detailes-img
 (fn [db _]
   (:issues-detailes-img db)))

(re-frame/reg-sub
 :reports/issues-tabular-img
 (fn [db _]
   (:issues-tabular-img db)))

(re-frame/reg-sub
 :reports/requirements-detailed-img
 (fn [db _]
   (:requirements-detailed-img db)))

(re-frame/reg-sub
 :reports/requirements-tabular-img
 (fn [db _]
   (:requirements-tabular-img db)))

(re-frame/reg-sub
 :reports/requirements-tabular-traceability-img
 (fn [db _]
   (:requirements-tabular-traceability-img db)))

(re-frame/reg-sub
 :reports/test-set-detailed-img
 (fn [db _]
   (:test-set-detailed-img db)))

(re-frame/reg-sub
 :reports/test-set-tabular-img
 (fn [db _]
   (:test-set-tabular-img db)))

(re-frame/reg-sub
 :reports/test-tabular-img
 (fn [db _]
   (:test-tabular-img db)))

(re-frame/reg-sub
 :reports/test-detailed-img
 (fn [db _]
   (:test-detailed-img db)))

(re-frame/reg-sub
 :reports/test-tabular-summaries-img
 (fn [db _]
   (:test-tabular-summaries-img db)))

(re-frame/reg-sub
 :reports/run-tabular-aggregated-img
 (fn [db _]
   (:run-tabular-aggregated-img db)))

(re-frame/reg-sub
 :reports/run-tabular-with-steps-img
 (fn [db _]
   (:run-tabular-with-steps-img db)))

(re-frame/reg-sub
 :reports/run-tabular-img
 (fn [db _]
   (:run-tabular-img db)))

(re-frame/reg-sub
 :reports/run-field-filter-fields
 (fn [db _]
   (:run-field-filter-fields db)))

(re-frame/reg-sub
 :reports/screen
 (fn [db _]
   (get-in db [:current-rd :screen])))

(re-frame/reg-sub :reports/export
 (fn [db _] (:export db)))